import axios from "axios";
import { executeIntent } from "../utils/IntentExecutor";
import IntentType from "../../intentexecutor/utils/IntentType";
import { getApiUrl } from "../../service/network/UrlMapper";
export default class StrapiService {

  async getDataBaseName() {
    const payload = {
      configurationKey: ["niramaya.cms.databasename"],
    };

    const result = await executeIntent(IntentType.GET_CONFIGURATION, payload);
    const response = result[0].configurationValue && JSON.parse(result[0].configurationValue);
    return response?.name;
  }

  async getArticles(organizationIdentifier, type, userIdentifier) {
    const dataBaseName = await this.getDataBaseName();
    let endpoint;
    if (dataBaseName) {
      endpoint = `${getApiUrl()["strapi_url"]}/api/${dataBaseName}?filters[organizationIdentifier][$eq]=${organizationIdentifier}&filters[category][$eq]=${type}`;
      if (userIdentifier) {
        endpoint += `&filters[userIdentifier][$eq]=${userIdentifier}`;
      }
    }

    const res = await axios.get(endpoint);
    return res.data;
  }

  async deleteBlog(id) {
    const dataBaseName = await this.getDataBaseName();
    let endpoint;
    if (dataBaseName) {
      endpoint = `${getApiUrl()["strapi_url"]}/api/${dataBaseName}/${id}`;
    }

    const res = await axios.delete(endpoint);
    return res.data;
  }

  async uploadBlog(obj) {
    const dataBaseName = await this.getDataBaseName();
    return await axios.post(`${getApiUrl()["strapi_url"]}/api/${dataBaseName}`, {
      data: obj,
    });
  }


  async updateBlog(id, obj) {
    const dataBaseName = await this.getDataBaseName();
    return await axios.put(`${getApiUrl()["strapi_url"]}/api/${dataBaseName}/${id}`, {
      data: obj,
    });
  }

  async getBlog(id) {
    const dataBaseName = await this.getDataBaseName();
    if (dataBaseName) {
      const endpoint = `${getApiUrl()["strapi_url"]}/api/${dataBaseName}/${id}`;
      const res = await axios.get(endpoint);
      return res.data;
    }
  }

  async uploadImage(file, existingImageId) {
    try {
      if (existingImageId) {
        await axios.delete(`${getApiUrl()["strapi_url"]}/api/upload/files/${existingImageId}`);
      }
      const formData = new FormData();
      formData.append("files", file);

      const res = await axios.post(`${getApiUrl()["strapi_url"]}/api/upload`, formData);
      const uploaded = res.data[0];

      return { url: `${getApiUrl()["strapi_url"]}${uploaded.url}`, id: uploaded.id };
    } catch (error) {
      console.error("Upload failed:", error);
      return { url: null, id: null };
    }
  };

  async getTemplate(type, organzationIdentifier) {
    const endpoint = `${getApiUrl()["strapi_url"]}/api/templates?filters[type][$eq]=${type}&filters[organizationIdentifier][$eq]=${organzationIdentifier}`;
    const res = await axios.get(endpoint);
    return res.data;
  }

  async updateTemplate(id, obj) {
    return await axios.put(`${getApiUrl()["strapi_url"]}/api/templates/${id}`, {
      data: obj,
    });
  }

  async getTrainingModules(organizationIdentifier) {
    // Fetch modules where module org matches or is null
    const endpoint = `${getApiUrl()["strapi_url"]}/api/training-modules?` +
      `filters[$or][0][organizationIdentifier][$eq]=${organizationIdentifier}` +
      `&filters[$or][1][organizationIdentifier][$null]=true` +
      `&populate[training_items][populate]=video,training_roles` +
      `&populate[training_roles]=*` +
      `&sort=sequenceId:asc`;
    const res = await axios.get(endpoint);
    return res.data;
  }

  async getTrainingModule(id) {
    const res = await axios.get(
      `${getApiUrl()["strapi_url"]}/api/training-modules/${id}?populate[training_roles]=*`
    );
    return res.data;
  }

  async addTrainingModule(obj) {
    return await axios.post(`${getApiUrl()["strapi_url"]}/api/training-modules`, {
      data: obj,
    });
  }

  async updateTrainingModule(id, obj) {
    return await axios.put(
      `${getApiUrl()["strapi_url"]}/api/training-modules/${id}`,
      { data: obj }
    );
  }

  async deleteTrainingModule(id) {
    return await axios.delete(
      `${getApiUrl()["strapi_url"]}/api/training-modules/${id}`
    );
  }

  async getTrainingItem(id) {
    const res = await axios.get(
      `${getApiUrl()["strapi_url"]}/api/training-items/${id}?populate=*`
    );
    return res.data;
  }

  async uploadDocument(file) {
    const formData = new FormData();
    formData.append("files", file);
    const res = await axios.post(`${getApiUrl()["strapi_url"]}/api/upload`, formData);
    const uploaded = res.data[0];
    return uploaded?.id;
  };

  async addTrainingItem(obj) {
    return await axios.post(`${getApiUrl()["strapi_url"]}/api/training-items`, {
      data: obj,
    });
  }

  async updateTrainingItem(id, obj) {
    return await axios.put(
      `${getApiUrl()["strapi_url"]}/api/training-items/${id}`,
      { data: obj }
    );
  }

  async deleteTrainingItem(id) {
    return await axios.delete(
      `${getApiUrl()["strapi_url"]}/api/training-items/${id}`
    );
  }
}

export const { getArticles, uploadBlog, uploadImage, getTemplate, updateTemplate, getTrainingModules, getTrainingModule, addTrainingModule, deleteTrainingModule, updateTrainingModule, getTrainingItem, addTrainingItem, updateTrainingItem, deleteTrainingItem, uploadDocument } = new StrapiService();
